module.exports = __webpack_public_path__ + "static/media/1.97306c65.JPG";